import React, { useEffect, useRef, useState } from 'react';
import ReactPaginate from "react-paginate";
import InputForm from "../../components/Form/InputForm.js";
import Layout from "../../components/Layout.js";
import Search from "../../components/Form/Search.js";
import MenuDots from "../../components/MenuDots.js";
import '../../assets/styles/pages/Processo/Processo.scss'
import 'pure-css-loader/src/loader-default.sass';
import business from "../../services/business.js";
import layout from '../../lib/layout.js';
import tools from '../../lib/tools.js';
import config from '../../config/config.js';
import ModalAlert from '../../components/Modais/ModalAlert.js';
import { toast as alert } from "react-toastify";
import ModalDuplicar from '../../components/Modais/ModalDuplicar.js';
import moment from 'moment';

export default function Processo({ name, id }) {
  document.title = 'säästo';

  const user = config.get();
  const [pager, setPager] = useState({
    page: 1,
    total_pages: 0,
    total_rows: 0,
  });
  const [meusProcessosBtn, setMeusProcessosBtn] = useState(false)
  const [filtro, setFiltro] = useState(false)
  const [filtros, setFiltros] = useState({
    id_operadora: (!config.isSaastoUser()) ? user?.id_operadora : '',
    desc_operadora: (!config.isSaastoUser()) ? user?.desc_operadora : '',
    data_criacao_inicio: '',
    data_criacao_fim: '',
    data_conclusao_inicio: '',
    data_conclusao_fim: '',
    id_usuario: '',
    meus_processos: '',
    situacao: '',
    id_area_atuacao: '',
    id_especialidade: '',
    id_assistente: '',
    id_enfermeira: '',
    id_desempatador: '',
  });
  const [blockReload, setBlockReload] = useState(false);

  const [processos, setProcessos] = useState([])
  const [options, setOptions] = useState({})
  const [modalData, setModalData] = useState({});

  const circleColors = [
    "circle-none",
    "circle-none",
    "circle-progress",
    "circle-done"
  ];

  const [modalDataDuplicar, setModalDataDuplicar] = useState({
    id: null,
    id_protocolo: null,
    id_processo_tipo: null,
    show: false
  });

  const searchOperadora = async (e) => {
    e.preventDefault();
    return await business.getOperadora(e.target.value);
  }

  const searchEspecialidade = async (e) => {
    e.preventDefault();
    return await business.getEspecialidade(e.target.value);
  };

  const searchAreaAtuacao = async (e) => {
    e.preventDefault();
    return await business.getAreaAtuacao(e.target.value, 12, 1, filtros?.id_especialidade);
  };

  const searchResponsavel = async (e) => {
    e.preventDefault();
    return await business.getResponsaveisByOperadora(filtros?.id_operadora, e.target.value);
  }

  const searchDesempatador = async (e) => {
    e.preventDefault();
    return await business.getDesempatadores(e.target.value);
  }

  const searchAssistente = async (e) => {
    e.preventDefault();
    return await business.getAssistentes(e.target.value);
  }

  const searchEnfermeira = async (e) => {
    e.preventDefault();
    return await business.getEnfermeiras(e.target.value);
  }

  const getCombosOPS = async () => {

    let etapas = [
      { id: 0, nome: 'Todas as etapas' },
      { id: 12, nome: 'Rascunho' },
      { id: 1, nome: 'Espera' },
      { id: 2, nome: 'Análise' },
      { id: 6, nome: 'Análise técnica' },
      { id: 8, nome: 'Ciência de abertura' },
      { id: 7, nome: 'Consenso Pós' },
      { id: 9, nome: 'Definir desempatador' },
      { id: 3, nome: 'Análise desempatador' },
      { id: 10, nome: 'Validação' },
      { id: 11, nome: 'Ciência de conclusão' },
      { id: 4, nome: 'Finalizado' },
      { id: 5, nome: 'Cancelado' }
    ];
    let status = [
      { id: 0, nome: 'Todos os status' },
      { id: 24, nome: 'Não enviado' },
      { id: 4, nome: 'Pendência técnica' },
      { id: 3, nome: 'Pendência administrativa' },
      { id: 7, nome: 'Finalizado' },
      { id: 12, nome: 'Finalizado por Consenso' },
      { id: 8, nome: 'Cancelado' },
    ];
    let situacao = [
      { id: '', nome: 'Todas as situações' },
      { id: 'rascunho', nome: 'Rascunho' },
      { id: 'nao-iniciado', nome: 'Não iniciado' },
      { id: 'pausado', nome: 'Pausado' },
      { id: 'atrasado', nome: 'Atrasado' },
      { id: 'andamento', nome: 'Em andamento' },
      { id: 'cancelado', nome: 'Cancelado' },
      { id: 'concluido', nome: 'Concluido' },
    ];
    setOptions({ ...{ etapas, status, situacao }, ...options })
  }

  const getCombos = async () => {

    let etapas = [
      { id: 0, nome: 'Todas as etapas' },
      { id: 2, nome: 'Análise' },
      { id: 3, nome: 'Análise desempatador/especialista' },
      { id: 6, nome: 'Análise técnica' },
      { id: 316, nome: 'Auditoria' },
      { id: 317, nome: 'Auditoria (Pós)' },
      { id: 5, nome: 'Cancelado' },
      { id: 8, nome: 'Ciência de abertura' },
      { id: 11, nome: 'Ciência de conclusão' },
      { id: 318, nome: 'Ciência de conclusão' },
      { id: 7, nome: 'Consenso Pós' },
      { id: 13, nome: 'Consenso Pós (Enfermeira)' },
      { id: 14, nome: 'Consenso Pré' },
      { id: 9, nome: 'Definir desempatador/especialista' },
      { id: 1, nome: 'Espera' },
      { id: 4, nome: 'Finalizado' },
      { id: 15, nome: 'Reabertura' },
      { id: 12, nome: 'Rascunho' },
      { id: 10, nome: 'Validação' }
    ];
    let status = [
      { id: 0, nome: 'Todos os status' },
      { id: 11, nome: 'Acolhimento' },
      { id: 43, nome: 'Acolhimento' },
      { id: 44, nome: 'Aguardando aceites' },
      { id: 27, nome: 'Aguardando ajuste do desempatador' },
      { id: 25, nome: 'Aguardando assistente' },
      { id: 31605, nome: 'Aguardando auditor' },
      { id: 31705, nome: 'Aguardando auditor' },
      { id: 14, nome: 'Aguardando ciência dos envolvidos' },
      { id: 22, nome: 'Aguardando desempatado/especialista' },
      { id: 23, nome: 'Aguardando enfermeira' },
      { id: 23, nome: 'Aguardando interação da enfermeira' },
      { id: 1, nome: 'Aguardando início' },
      { id: 15, nome: 'Aguardando PA' },
      { id: 18, nome: 'Analisando consenso pós' },
      { id: 2, nome: 'Analisando informações' },
      { id: 51, nome: 'Auditoria Concluída' },
      { id: 31703, nome: 'Auditoria Concluída' },
      { id: 46, nome: 'Cancelado pós parecer' },
      { id: 5, nome: 'Concluído' },
      { id: 10, nome: 'Concluído consenso' },
      { id: 31, nome: 'Concluído consenso pós' },
      { id: 39, nome: 'Concluído por consenso parcial' },
      { id: 21, nome: 'Devolvido para ajustes' },
      { id: 41, nome: 'Devolvido para säästö' },
      { id: 4, nome: 'Pendência técnica' },
      { id: 6, nome: 'Em análise pelo desempatador' },
      { id: 50, nome: 'Em auditoria' },
      { id: 31702, nome: 'Em auditoria' },
      { id: 9, nome: 'Em consenso' },
      { id: 26, nome: 'Encaminhado consenso para validação da OPS' },
      { id: 17, nome: 'Encaminhado para consenso' },
      { id: 28, nome: 'Encaminhado para enfermeira' },
      { id: 34, nome: 'Encaminhado para JMO' },
      { id: 49, nome: 'Encerrado o Prazo - Escolher Desempatador' },
      { id: 47, nome: 'Enviar convites' },
      { id: 10948, nome: 'Escolher desempatador' },
      { id: 42, nome: 'Finalizado por consenso pré' },
      { id: 12, nome: 'Finalizado por Consenso' },
      { id: 3, nome: 'Pendência administrativa' },
      { id: 24, nome: 'Rascunho' },
      { id: 20, nome: 'Parecer em análise' },
      { id: 8, nome: 'Processo cancelado' },
      { id: 7, nome: 'Processo finalizado' },
      { id: 35, nome: 'Profissional assistente optou por abstenção' },
      { id: 36, nome: 'Profissional assistente optou por consenso' },
      { id: 37, nome: 'Profissional assistente selecionou desempatador' },
      { id: 45, nome: 'Reabertura de processo' },
      { id: 13, nome: 'Recusa de consenso' },
      { id: 33, nome: 'Sem contato com profissional assistente' },
      { id: 19, nome: 'Solicitar exames complementares' },
      { id: 30, nome: 'Voltar à etapa Análise Técnica' },
    ];
    let situacao = [
      { id: '', nome: 'Todas as situações' },
      { id: 'rascunho', nome: 'Rascunho' },
      { id: 'nao-iniciado', nome: 'Não iniciado' },
      { id: 'pausado', nome: 'Pausado' },
      { id: 'atrasado', nome: 'Atrasado' },
      { id: 'andamento', nome: 'Em andamento' },
      { id: 'cancelado', nome: 'Cancelado' },
      { id: 'concluido', nome: 'Concluido' },
    ];
    setOptions({ ...{ etapas, status, situacao }, ...options })
  }

  const setModel = (name, value) => {
    setFiltros({ ...filtros, ...{ [name]: value } });
  }

  const setSearch = (name, data) => {
    setFiltros({
      ...filtros, ...{
        [`id_${name}`]: data?.id || '',
        [`desc_${name}`]: data?.nome || '',
      }
    });
  }

  const handlePageClick = (e) => {
    if (meusProcessosBtn === true) {
      var userId = user.id;
    }
    getSearch(e.selected + 1, '', true, userId);
  };

  const getDias = async (inicio_processo) => {
    let total = await tools.diasUteisEntreDatas(inicio_processo, config.dataHoraAtual());
    return total;
  }

  const getSearch = async (page = null, value = '', loading = true, user_id = false) => {
    setLoading(loading);
    let processos = await business.getAllProcessos((page === null) ? pager.page : page, 10, value, {
      id_processo_tipo: id,
      id_operadora: (config.isOperadora()) ? user.id_operadora : ((filtros?.id_operadora) ? filtros.id_operadora : ''),
      id_assistente: filtros?.id_assistente || '',
      id_enfermeira: filtros?.id_enfermeira || '',
      id_desempatador: (config.isEspecialista()) ? user.id : filtros?.id_desempatador,
      id_processo_etapa: filtros?.id_processo_etapa || '',
      id_processo_etapa_status: filtros?.id_processo_etapa_status || '',
      id_usuario: filtros?.id_usuario || '',
      id_especialidade: filtros?.id_especialidade,
      id_area_atuacao: filtros?.id_area_atuacao,
      data_criacao_inicio: filtros?.data_criacao_inicio || '',
      data_criacao_fim: filtros?.data_criacao_fim || '',
      data_conclusao_inicio: filtros?.data_conclusao_inicio || '',
      data_conclusao_fim: filtros?.data_conclusao_fim || '',
      situacao: filtros?.situacao || '',
      meus_processos: user_id || ''
    });

    let data = processos?.response || [];

    data = data.map(async (row) => {
      row.dias = await getDias(row.inicio_processo).then(value => { return value; });
      row.diasPA = await getDias(row.marcador_sla).then(value => { return value; });
      return row;
    });

    Promise.all(data).then((results) => {
      setProcessos(results);
    });

    if (processos?.response && pager.page && processos?.pager?.paginas < pager.page) {
      pager.page = 1;
      return getSearch();
    }
    pager.page = processos?.pager?.pagina;
    setPager({
      page: processos?.pager?.pagina,
      total_pages: processos?.pager?.paginas,
      total_rows: processos?.pager?.total
    });
    setLoading(false);
    setSearchLoading(false);
  }

  const handleWindowSizeChange = (mobileSize) => {
    let checkIsMobile = window.innerWidth < mobileSize;
    setIsMobile(checkIsMobile);
  }

  const cancelar = async (e, form) => {
    e.preventDefault();
    if (form?.id) {
      return setModalData({
        text: 'Deseja realmente cancelar o processo ' + form?.id_protocolo + '?',
        show: true,
        buttonCancel: true,
        onAccept: async (e) => {
          e.preventDefault();
          form.id_processo_etapa = 5;
          form.id_processo_etapa_status = 8;
          let res = await business.cancelarProcesso(form?.id);
          if (res?.errors?.length) {
            (res.errors).forEach(e => alert.error(e));
          } else {
            await getSearch(null, '', false);
            alert.success('O processo foi cancelado com sucesso!');
          }
        }
      })
    }
  }

  const cancelarPosParecer = async (e, form) => {
    e.preventDefault();
    if (form?.id) {
      return setModalData({
        text: 'Deseja realmente cancelar o processo pós parecer ' + form?.id_protocolo + '?',
        show: true,
        buttonCancel: true,
        onAccept: async (e) => {
          e.preventDefault();
          form.id_processo_etapa = 5;
          form.id_processo_etapa_status = 46;
          let res = await business.cancelarPosParecerProcesso(form?.id);
          if (res?.errors?.length) {
            (res.errors).forEach(e => alert.error(e));
          } else {
            await getSearch(null, '', false);
            alert.success('O processo pós parecer foi cancelado com sucesso!');
          }
        }
      })
    }
  }

  const limparFiltros = () => {
    setFiltros({});
    setFiltro(false);
    setBlockReload(false);
    window.location.reload();
  }

  const getMeusProcessos = async () => {
    const toggleButton = !meusProcessosBtn;
    setMeusProcessosBtn(toggleButton);

    const userId = (toggleButton) ? user.id : null;
    getSearch(1, '', true, userId);
  };

  const createCircleTitle = (titulo, data, status) => {
    let tituloFormatado = `${titulo}. ${data ? `${parseInt(status) === 3 ? "Leitura" : "Enviado"} em ${moment(data).format('DD/MM/YYYY HH:mm')}.` : ""}`;

    return tituloFormatado;
  };

  useEffect(() => {
    window.addEventListener('resize', () => {
      return handleWindowSizeChange(1180);
    });
  }, []);

  const [isMobile, setIsMobile] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const responsavelRef = useRef();

  useEffect(() => {
    (async () => {
      await getSearch();
      if (config.isOperadora()) {
        getCombosOPS()
      }
      else {
        getCombos()
      };
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, config])

  //  Autoreload de mouse estiver parado ou janela inativa apenas
  const [mouseIdle, setMouseIdle] = useState(false);

  useEffect(() => {
    let idleTimer;

    const handleMouseMove = () => {
      clearTimeout(idleTimer);
      setMouseIdle(false);
      idleTimer = setTimeout(() => {
        setMouseIdle(true);
      }, 50000); // Tempo para considerar mouse inativo 50000
    };

    const handleWindowFocus = () => {
      setMouseIdle(false);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('focus', handleWindowFocus);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('focus', handleWindowFocus);
      clearTimeout(idleTimer);
    };
  }, []);

  useEffect(() => {
    if (mouseIdle && !blockReload && !meusProcessosBtn) {
      const interval = setTimeout(() => {
        window.location.reload();
      }, 5000); //5000

      return () => clearTimeout(interval); // Limpa o timeout quando o componente é desmontado
    }
  }, [mouseIdle, blockReload, meusProcessosBtn]);

  return (
    <Layout className="view-listagem">
      <ModalAlert title={modalData?.title} text={modalData?.text} show={modalData?.show} onAccept={modalData?.onAccept} onClose={modalData?.onClose} buttonCancel={modalData?.buttonCancel} setModel={setModalData} />
      <ModalDuplicar data={modalDataDuplicar} onChange={async (e, slug, id_processo) => {
        e.stopPropagation();
        if (slug && id_processo) {
          tools.openURL(`/${slug}/${id_processo}`);
        } else {
          await getSearch(null, '', false);
        }
      }} hideModal={async (e) => {
        e.preventDefault();
        setModalDataDuplicar({
          id: null,
          id_protocolo: null,
          id_processo_tipo: null,
          show: false
        });
      }} />
      <p className="page-title">Listagem de processos</p>
      <h2 className="title flex jc-sb ai-fe black-text mb-40 gap-10">
        {layout.title(name)}
      </h2>
      <div className={`flex jc-sb ai-fc mb-${filtro ? `2` : `6`}0`}>
        <div className="container-search-filter flex ai-fc jc-sb gap-25">
          <Search value={filtro?.texto || ''} name="texto" onChange={(value) => {
            setSearchLoading(true);
            getSearch(1, value, false);
            setModel('texto', value);
          }}
            searchOnTyping={isMobile}
            loading={searchLoading} />
          {(!config.isEspecialista()) && <button className={`btn btn-${!meusProcessosBtn ? `outline-` : ''}primary f700-16 jc-sb w-350px`}
            onClick={getMeusProcessos}>
            <span className="desktop">Meus processos</span> <i className="icon icon-eye i-20 blue" />
          </button>}
          <button className={`btn btn-${!filtro ? `outline-` : ''}primary filtros f700-16 jc-sb`} onClick={() => setFiltro(!filtro)}>
            <span className="desktop">Filtrar </span> <i className={`icon ${!filtro ? `icon-settings-sliders ` : `icon-exit `}i-20 ml-5 blue`} />
          </button>
        </div>
      </div>
      {filtro && <div className="filtro-consulta form-container grid col-12">
        <div className="w-100">
          <div className="grid col-12 md-gap">
            <InputForm label="Operadora" type="search" onResetSearch={() => {
              filtros.id_operadora = '';
              filtros.desc_operadora = '';
              responsavelRef.current.clearSearch();
            }} {...((config.isOperadora()) ? { disabled: true } : {})} className="span-2" onSearch={searchOperadora} name="id_operadora" model={(...params) => setSearch('operadora', ...params)}
              exibicao={false} value={filtros.desc_operadora} />
            <InputForm label="Responsável Operadora" type="search" ref={responsavelRef} {...((config.isEspecialista() || !filtros.id_operadora) ? { disabled: true } : {})} className="span-2" onSearch={searchResponsavel} name="id_usuario" model={(...params) => setSearch('usuario', ...params)}
              exibicao={false} value={filtros.id_usuario} />
            <InputForm label="Etapa" className="span-3" name="id_processo_etapa" type="select"
              value={filtros.id_processo_etapa} options={options?.etapas} model={setModel} />
            <InputForm label="Status" className="span-3" name="id_processo_etapa_status" type="select"
              value={filtros.id_processo_etapa_status} options={options?.status} model={setModel} />
            <InputForm label="Situação" className="span-2" name="situacao" type="select"
              value={filtros.situacao} options={options?.situacao} model={setModel} />
          </div>
        </div>
        <div className="w-100">
          <div className="grid col-12 md-gap">
            <InputForm
              label="Especialidade"
              type="search"
              className="span-2"
              placeholder="Pesquisar..."
              onSearch={searchEspecialidade}
              name="id_especialidade"
              value={filtros?.desc_especialidade}
              model={(...params) => {
                setSearch('especialidade', ...params)
              }}
              onResetSearch={() => setFiltros(prevState => ({
                ...prevState,
                id_especialidade: ''
              }))}
            />
            <InputForm
              label="Área de atuação"
              type="search"
              className="span-4"
              placeholder="Pesquisar..."
              onSearch={searchAreaAtuacao}
              name="id_area_atuacao"
              value={filtros.desc_area_atuacao}
              model={(...params) => {
                setSearch('area_atuacao', ...params)
              }}
              onResetSearch={() => setFiltros(prevState => ({
                ...prevState,
                id_area_atuacao: ''
              }))}
            />
            <InputForm
              label="Assistente responsável"
              type="search"
              className="span-2"
              placeholder="Pesquisar..."
              onSearch={searchAssistente}
              name="id_assistente"
              value={filtros.desc_assistente}
              model={(...params) => {
                setSearch('assistente', ...params)
              }}
              onResetSearch={() => setFiltros(prevState => ({
                ...prevState,
                id_assistente: ''
              }))}
            />
            <InputForm
              label="Enfermeira responsável"
              type="search"
              className="span-2"
              placeholder="Pesquisar..."
              onSearch={searchEnfermeira}
              name="id_enfermeira"
              value={filtros.desc_enfermeira}
              model={(...params) => {
                setSearch('enfermeira', ...params)
              }}
              onResetSearch={() => setFiltros(prevState => ({
                ...prevState,
                id_enfermeira: ''
              }))}
            />
            <InputForm
              label="Nome do profissional desempatador"
              type="search"
              className="span-2"
              placeholder="Pesquisar..."
              onSearch={searchDesempatador}
              name="id_desempatador"
              value={filtros.desc_desempatador}
              model={(...params) => {
                setSearch('desempatador', ...params)
              }}
              onResetSearch={() => setFiltros(prevState => ({
                ...prevState,
                id_desempatador: ''
              }))}
            />
          </div>
        </div>
        <div className="w-100">
          <div className="grid col-12">
            <InputForm label="Data de cadastro (Inicial)" type="date" id="data_criacao_inicio" name="data_criacao_inicio" model={setModel} value={filtros.data_criacao_inicio} />
            <span className="text-center interval">-</span>
            <InputForm label="Data de cadastro (Final)" type="date" className="input-padding" id="data_criacao_fim" name="data_criacao_fim" model={setModel} value={filtros.data_criacao_fim} />
            <InputForm label="Data de conclusão (Inicial)" type="date" id="data_conclusao_inicio" name="data_conclusao_inicio" model={setModel} value={filtros.data_conclusao_inicio} />
            <span className="text-center interval">-</span>
            <InputForm label="Data de conclusão (Final)" type="date" className="input-padding" id="data_conclusao_fim" name="data_conclusao_fim" model={setModel} value={filtros.data_conclusao_fim} />
            <button className="btn btn-primary f700-16 button-filtrar" onClick={() => {
              getSearch(1, filtros?.texto || '', true);
              setBlockReload(true);
            }}>
              Aplicar filtros
            </button>
            <span className="pointer float-right ml-20 mt-30" onClick={limparFiltros}>
              <i className="icon icon-trash watermelon i-25" title="Limpar filtros" />
            </span>
          </div>
        </div>
      </div>}

      {
        loading ? <div className="loader loader-default is-active" /> : (<div>
          <div className="table-mobile">
            {(processos || []).map((p, i) => {
              return <div className="item pointer" key={`mobile-${i}`}>
                <div>

                  <div className="fn-16 linha flex jc-sb" onClick={() => tools.openURL(`/${p.slug_processo_tipo}/${p.id}`)}>
                    ID
                    <span>
                      <strong>{p.id_protocolo}</strong>
                    </span>
                  </div>
                  <div className="fn-16 linha flex jc-sb">
                    Responsável (Operadora)
                    <span>
                      {p.desc_operadora}
                    </span>
                  </div>
                  <div className="fn-16 linha flex jc-sb">
                    Beneficiário
                    <span>
                      {p.nome_beneficiario}
                    </span>
                  </div>
                  <div className="fn-16 linha flex jc-sb">
                    P. Assistente
                    <span>
                      {p.nome_profissional}
                    </span>
                  </div>
                  <div className="fn-16 linha flex jc-sb">
                    Nº guia
                    <span className="flex jc-fc gap-5 ai-fc">
                      {p?.guia}
                    </span>
                  </div>
                  <div className="fn-16 linha flex jc-sb">
                    Etapa/Status
                    <span className="flex jc-fc gap-5 ai-fc">
                      {p.desc_processo_etapa} - {p.desc_processo_etapa_status}
                    </span>
                  </div>
                  {(!config.isEspecialista()) && <div className="fn-16 linha flex jc-sb">
                    Prazo säästö
                    <span className="flex jc-fc gap-5 ai-fc">
                      {moment(p?.expiracao_processo).format('DD/MM/YYYY')}
                    </span>
                  </div>}
                  {(!config.isOperadora()) && <div className="fn-16 linha flex jc-sb">
                    Prazo ANS
                    <span className="flex jc-fc gap-5 ai-fc">
                      {moment(p?.data_ans).format('DD/MM/YYYY')}
                    </span>
                  </div>}
                  <div className="fn-16 linha flex jc-sb" onClick={() => tools.openURL(`/${p.slug_processo_tipo}/${p.id}`)}>
                    Situação
                    <span className={`badge badge-${p.situacao}`}>
                      {p.situacao !== 'andamento' ? <span className="display-none">{p.situacao}</span> : (((tools.formatDateSQL(p.inicio_processo) === tools.getDate()) || (p.dias - p.pausa_dias) <= 0) ? 0 : (p.dias - p.pausa_dias - 1)) + " / " + parseInt(p?.operadora_dias)}
                    </span>
                  </div>
                  {(!config.isEspecialista()) && <div className="fn-16 linha flex jc-sb">
                    Data de conclusão
                    <span className="flex jc-fc gap-5 ai-fc">
                      {p?.data_conclusao ? moment(p?.data_conclusao).format('DD/MM/YYYY') : '-'}
                    </span>
                  </div>}
                </div>
                <div className="w-100 flex jc-fc">
                  <MenuDots row={p} menuPositionTop={true} menuItens={[
                    {
                      label: 'Visualizar',
                      icon: 'icon-eye blue i-25',
                      className: 'menu-icon',
                      onClick: () => (filtro || meusProcessosBtn) ? (tools.openURLTab(`/${p.slug_processo_tipo}/${p.id}`)) : (tools.openURL(`/${p.slug_processo_tipo}/${p.id}`))
                    },
                    {
                      label: 'Duplicar',
                      icon: 'icon-duplicate blue i-25',
                      className: 'menu-icon',
                      noDisplay: [6, 7].includes(parseInt(config.user.tipo)),
                      onClick: (e, item) => {
                        e.preventDefault();
                        setModalDataDuplicar({
                          id: item.id,
                          id_protocolo: item.id_protocolo,
                          id_processo_tipo: item.id_processo_tipo,
                          show: true
                        });
                      }
                    },
                    {
                      label: 'Dossiê',
                      icon: 'icon-dossie blue i-25',
                      className: 'menu-icon',
                      noDisplay: (parseInt(p.id_processo_tipo) !== 3),
                      disabled: ![4].includes(parseInt(p.id_processo_etapa)),
                      onClick: (e) => {
                        e.preventDefault();
                        tools.openUrlExternal(`/${p.id}/${p.id_processo_etapa_status}/dossie`)
                      }
                    },
                    {
                      label: 'Cancelar',
                      icon: 'icon-cross-circle blue i-25',
                      className: 'menu-icon',
                      noDisplay: (!config.temPermissao('listagem:processo_cancelar:editar') || ([4, 5].includes(parseInt(p.id_processo_etapa)))),
                      disabled: !config.temPermissao('listagem:processo_cancelar:editar'),
                      onClick: async (e) => {
                        e.stopPropagation()
                        cancelar(e, p);
                      }
                    },
                    {
                      label: 'Cancelar pós parecer',
                      icon: 'icon-cross-circle blue i-25',
                      className: 'menu-icon',
                      noDisplay: (!config.temPermissao('listagem:processo_cancelar:editar') || ([4, 5].includes(parseInt(p.id_processo_etapa)))),
                      disabled: !config.temPermissao('listagem:processo_cancelar:editar'),
                      onClick: async (e) => {
                        e.stopPropagation()
                        cancelarPosParecer(e, p);
                      }
                    }
                  ]} />
                </div>
              </div>
            })}
            {(!loading && (!processos || !processos.length)) ? <div>Nenhum processo foi encontrado.</div> : ''}
          </div>
          <table className="w-100 table-desktop">
            <thead className="f300-14">
              <tr>
                <th className="text-center bold">ID</th>
                {(user.tipo !== '2') && <th className="text-left bold">Operadora <br />(Responsável)</th>}
                <th className="text-left bold">Beneficiário <br />(P. Assistente)</th>
                <th className="text-center bold">Nº guia</th>
                <th className="text-center bold">Responsáveis säästo <br />(Assistente / Enfermeira)</th>
                <th className="text-center bold">Etapa/Status</th>
                {(!config.isEspecialista()) && <th className="text-center bold">Prazo säästö</th>}
                <th className="text-center bold">Prazo ANS</th>
                <th className="text-center bold">Situação</th>
                <th></th>
                {(!config.isOperadora() && !config.isEspecialista()) && <th className="text-center bold">Data de conclusão</th>}
                <th></th>
              </tr>
            </thead>
            <tbody>
              {(processos || []).map((p, i) => {
                return <tr key={`desktop-${i}`} className={`hover-highlight fn-14${((([3, 4, 19, 24, 26].includes(parseInt(p.id_processo_etapa_status))) && (config.isOperadora())) || (([41].includes(parseInt(p.id_processo_etapa_status))) && config.isSaastoUser())) ? ' bold-red' : ''}`} onClick={() => (filtro || meusProcessosBtn) ? (tools.openURLTab(`/${p.slug_processo_tipo}/${p.id}`)) : (tools.openURL(`/${p.slug_processo_tipo}/${p.id}`))} >
                  <td className="text-center" style={{ minWidth: '100px' }}>
                    <span className={`badge badge-${p.situacao} badge-no-after`}>
                      {p.id_protocolo}
                    </span>
                  </td>
                  {(user.tipo !== '2') && <td className="text-left">{p.desc_operadora}<br />({p.nome_usuario})</td>}
                  <td className="text-left">{p.nome_beneficiario} <br />({p.nome_profissional})</td>
                  <td className="text-center" style={{ minWidth: '95px' }}>
                    {p.guia}
                  </td>
                  <td className="text-center" style={{ minWidth: '120px' }}>
                    {p.nome_assistente ? p.nome_assistente : '-'}<br />{p.nome_enfermeira ? p.nome_enfermeira : '-'}
                  </td>
                  <td className="text-center" style={{ minWidth: '180px' }}>
                    <div className="flex ai-fc jc-fc fn-14 gap-5 cursor-help" title={`${p?.historico_etapa_status_data_cadastro ? 'Última alteração: ' + moment(p?.historico_etapa_status_data_cadastro).format('DD/MM/YYYY HH:mm:ss') : 'Sem registros'} ${p.nome_desempatador ? 'Desempatador: ' + p.nome_desempatador : ''}`}>
                      {p.desc_processo_etapa}:<br /> {p.desc_processo_etapa_status}
                    </div>
                  </td>
                  {(!config.isEspecialista()) && <td className="text-center" style={{ minWidth: '95px' }}>
                    {moment(p?.expiracao_processo).format('DD/MM/YYYY')}
                  </td>}
                  <td className="text-center" style={{ minWidth: '95px' }}>
                    {p.data_ans ? moment(p?.data_ans).format('DD/MM/YYYY') : '-'}
                  </td>
                  <td className="text-center">
                    <span className={`badge badge-${p.situacao}`}>
                      <span className="display-none"></span>
                      {p.situacao !== 'andamento' ? <span className="display-none">{p.situacao}</span> : (((tools.formatDateSQL(p.inicio_processo) === tools.getDate()) || (p.dias - p.pausa_dias) <= 0) ? 0 : (p.dias - p.pausa_dias - 1)) + " / " + (p.operadora_dias)}
                    </span>
                    {(parseInt(p.id_processo_tipo) === 3 && (parseInt(p.id_processo_etapa) !== 1 && parseInt(p.id_processo_etapa) !== 4 && parseInt(p.id_processo_etapa) !== 5 && parseInt(p.id_processo_etapa) !== 12)) &&
                      <span className="flex mt-5 lt-gap jc-fc">
                        <i
                          className={`circle ${circleColors[Number(p.leitura_abertura_bnf)]} cursor-help`}
                          title={createCircleTitle("Comunicação de abertura ao beneficiário", p.leitura_abertura_bnf_data, p.leitura_abertura_bnf)}
                        />
                        <i
                          className={`circle ${circleColors[Number(p.leitura_abertura_pa)]} cursor-help`}
                          title={createCircleTitle("Comunicação de abertura ao profissional assistente", p.leitura_abertura_pa_data, p.leitura_abertura_pa)}
                        />
                        <i
                          className={`circle ${circleColors[Number(p.leitura_fechamento_bnf)]} cursor-help`}
                          title={createCircleTitle("Comunicação de fechamento ao beneficiário", p.leitura_fechamento_bnf_data, p.leitura_fechamento_bnf)}
                        />
                        <i
                          className={`circle ${circleColors[Number(p.leitura_fechamento_pa)]} cursor-help`}
                          title={createCircleTitle("Comunicação de fechamento ao profissional assistente", p.leitura_fechamento_pa_data, p.leitura_fechamento_pa)}
                        />
                      </span>}
                  </td>
                  <td>
                    {((config.isSaastoUser()) && (p.id_processo_etapa === "9" || p.id_processo_etapa_status === "15") && p.marcador_sla && p.diasPA > 2) && <i className="icon icon-important i-20" title="Expirado prazo de 48hrs do Profissional Assistente." />}
                  </td>
                  {(!config.isOperadora() && !config.isEspecialista()) && <td className="text-center" style={{ minWidth: '95px' }}>
                    {p.data_conclusao ? moment(p?.data_conclusao).format('DD/MM/YYYY') : '-'}
                  </td>}
                  <td className="text-center" style={{ width: '35px' }}>
                    <MenuDots row={p} menuPositionTop={processos.length - i <= 2}
                      menuItens={[
                        {
                          label: 'Visualizar',
                          icon: 'icon-eye blue i-25',
                          className: 'menu-icon',
                          onClick: () => (filtro || meusProcessosBtn) ? (tools.openURLTab(`/${p.slug_processo_tipo}/${p.id}`)) : (tools.openURL(`/${p.slug_processo_tipo}/${p.id}`))
                        },
                        {
                          label: 'Duplicar',
                          icon: 'icon-duplicate blue i-25',
                          className: 'menu-icon',
                          noDisplay: [6, 7].includes(parseInt(config.user.tipo)),
                          onClick: (e, item) => {
                            e.preventDefault();
                            setModalDataDuplicar({
                              id: item.id,
                              id_protocolo: item.id_protocolo,
                              id_processo_tipo: item.id_processo_tipo,
                              show: true
                            });
                          }
                        },
                        {
                          label: 'Dossiê',
                          icon: 'icon-dossie blue i-25',
                          className: 'menu-icon',
                          noDisplay: (parseInt(p.id_processo_tipo) !== 3),
                          disabled: ![4].includes(parseInt(p.id_processo_etapa)),
                          onClick: (e) => {
                            e.preventDefault();
                            tools.openUrlExternal(`/${p.id}/${p.id_processo_etapa_status}/dossie`)
                          }
                        },
                        {
                          label: 'Cancelar',
                          icon: 'icon-cross-circle blue i-25',
                          className: 'menu-icon',
                          noDisplay: (!config.temPermissao('listagem:processo_cancelar:editar') || ([4, 5].includes(parseInt(p.id_processo_etapa)))),
                          disabled: !config.temPermissao('listagem:processo_cancelar:editar'),
                          onClick: async (e) => {
                            e.stopPropagation()
                            cancelar(e, p);
                          }
                        },
                        {
                          label: 'Cancelar pós parecer',
                          icon: 'icon-cross-circle blue i-25',
                          className: 'menu-icon',
                          noDisplay: (!config.temPermissao('listagem:processo_cancelar:editar') || ([4, 5].includes(parseInt(p.id_processo_etapa)))),
                          disabled: !config.temPermissao('listagem:processo_cancelar:editar'),
                          onClick: async (e) => {
                            e.stopPropagation()
                            cancelarPosParecer(e, p);
                          }
                        },
                      ]} />
                  </td>
                </tr>
              })}

              {(!loading && (!processos || !processos.length)) ? <tr>
                <td colSpan={8}>Nenhum processo foi encontrado</td>
              </tr> : ''}
            </tbody>
          </table>
          <div className="component pagination">
            <div className="pagination-container mt-30">
              {pager && pager.total_pages < 2 ? '' : <ReactPaginate
                previousLabel="«"
                nextLabel="»"
                breakLabel="..."
                breakClassName="break-me"
                page={pager.page - 1 ?? 0}
                forcePage={pager.page - 1 ?? 0}
                pageCount={pager.total_pages}
                marginPagesDisplayed={3}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName="pagination"
                subContainerClassName="pages pagination"
                activeClassName="active" />}
            </div>
          </div>
        </div>)
      }
    </Layout >
  );
}